import { QuestionTypes } from 'models/Question';

export const ReflectableQuestionTypes = [
  QuestionTypes.SINGLE,
  QuestionTypes.MULTIPLE,
  QuestionTypes.GRID,
];
